import React, { useState } from 'react';
import { X, Mail, Lock } from 'lucide-react';
import { useToast } from '../hooks/use-toast';

const LoginModal = ({ open, onClose }) => {
  const [mode, setMode] = useState('login');
  const [form, setForm] = useState({ email: '', password: '' });
  const { toast } = useToast();

  if (!open) return null;

  const submit = (e) => {
    e.preventDefault();
    toast({
      title: mode === 'login' ? 'Welcome back' : 'Account created',
      description: 'This is a demo — connect to backend to enable real auth.',
    });
    onClose();
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/80 backdrop-blur-sm" onClick={onClose} />
      <div className="relative w-full max-w-md bg-[#0d0d0d] border border-amber-400/30 rounded-2xl p-8">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 w-9 h-9 rounded-full hover:bg-white/5 flex items-center justify-center text-white/70 hover:text-amber-400 transition-colors"
        >
          <X size={18} />
        </button>

        <p className="text-amber-400 text-[11px] tracking-[0.32em] font-medium">
          {mode === 'login' ? 'WELCOME BACK' : 'JOIN KANGO 9'}
        </p>
        <h3 className="font-serif text-white text-3xl mt-2">
          {mode === 'login' ? 'Log in to your account' : 'Create your account'}
        </h3>

        <form onSubmit={submit} className="mt-7 space-y-4">
          <div className="relative">
            <Mail size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-white/40" />
            <input
              required
              type="email"
              placeholder="Email"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              className="w-full bg-transparent border border-white/15 rounded-lg pl-11 pr-4 py-3 text-white placeholder:text-white/30 focus:outline-none focus:border-amber-400"
            />
          </div>
          <div className="relative">
            <Lock size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-white/40" />
            <input
              required
              type="password"
              placeholder="Password"
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              className="w-full bg-transparent border border-white/15 rounded-lg pl-11 pr-4 py-3 text-white placeholder:text-white/30 focus:outline-none focus:border-amber-400"
            />
          </div>
          <button
            type="submit"
            className="w-full py-3.5 rounded-full bg-amber-400 text-[#0a0a0a] hover:bg-amber-300 transition-colors font-medium"
          >
            {mode === 'login' ? 'Log in' : 'Create account'}
          </button>
        </form>

        <div className="mt-6 text-center text-white/60 text-sm">
          {mode === 'login' ? "Don't have an account?" : 'Already have an account?'}{' '}
          <button
            onClick={() => setMode(mode === 'login' ? 'signup' : 'login')}
            className="text-amber-400 hover:underline"
          >
            {mode === 'login' ? 'Sign up' : 'Log in'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoginModal;
